








































import { Component, Vue, Prop } from "vue-property-decorator";
import { getCurrentTime } from "@/utils/base";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    MainHeader,
    NavLeft,
    LeaveConfirm,
  },
})
export default class Name extends Vue {
  private pageType: any = ""; // 编辑 or 新增
  private id: any = "";
  private data: any = {};
  private detail: any = {};
  private ifShowSaveConfirm: any = false;
  private noSaveText: any = "不保存，离开";
  private disabledDate: any = this.endDate();
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }

  private get patient() {
    return this.$store.state.patient;
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private get patientFileFilter() {
    return this.$store.state.patientFileFilter;
  }

  private edit() {
    this.$store.commit("updateIfCompose", true);
  }
  private save() {
    return new Promise((resolve, reject) => {
      this.$store.commit("updateIfCompose", false);
      this.$message.success("保存成功");
      this.getDetail();
      resolve(true);
    });
  }
  private getDetail() {
    this.data = {
      名称: "住院记录",
      create_time: getCurrentTime("yyyy-MM-dd HH:mm"),
      id: new Date().getTime(),
      病案首页: {
        名称: "病案首页",
        create_time: getCurrentTime("yyyy-MM-dd HH:mm"),
        id: new Date().getTime() + 1,
        file: [
          {
            name: "3V2A3032",
            type: "jpg",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/e56c3870926b414685670cf856a97ba2_3v2a3032.jpg",
          },
        ],
        content:
          '<div data-w-e-type="video" data-w-e-is-void><video poster="" controls="true" width="300" height="300"><source src="https://fqxk-test.i-tcm.cn/qhpicrootds/file/f5abc0dbe05f41d0b4c2c23e8540bd81_32秒视频.mp4" type="video/mp4"/></video></div><p><br></p><p><a href="https://fqxk-test.i-tcm.cn/qhpicrootds/file/c824a4c10a734f0184dfe45b715b9e9a_1628129811(1).jpg" target="_blank">我是文件链接</a> </p><p><span style="font-size: 16px;">你好</span></p><h1><span style="font-size: 16px;">目录</span></h1><p>😀</p><div data-w-e-type="todo"><input type="checkbox" disabled ><span style="font-size: 16px;">是否完成</span></div><pre><code >额发v热分v</code></pre><blockquote><span style="font-size: 16px;">知识储备打包</span></blockquote><table style="width: auto;"><tbody><tr><th colSpan="1" rowSpan="1" width="111"></th><th colSpan="1" rowSpan="1" width="95"></th><th colSpan="1" rowSpan="1" width="93"></th></tr><tr><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td></tr></tbody></table><table style="width: auto;"><tbody><tr><th colSpan="1" rowSpan="1" width="133">类别</th><th colSpan="1" rowSpan="1" width="108">单位</th><th colSpan="1" rowSpan="1" width="151">数量</th></tr><tr><td colspan="1" rowspan="1" width="auto" style="text-align: center;">食物</td><td colspan="1" rowspan="1" width="auto" style="text-align: center;">箱</td><td colspan="1" rowspan="1" width="auto" style="text-align: center;">3</td></tr><tr><td colspan="1" rowspan="1" width="auto" style="text-align: center;">饮料</td><td colspan="1" rowspan="1" width="auto" style="text-align: center;">瓶</td><td colspan="1" rowspan="1" width="auto" style="text-align: center;">34</td></tr></tbody></table><p><img src="https://fqxk-test.i-tcm.cn/qhpicrootds/file/0c091f763b4741a990873e7c0438aef5_22fa0e41322ec341b265cfd9c9a77bdd.gif" alt="" data-href="https://fqxk-test.i-tcm.cn/qhpicrootds/file/0c091f763b4741a990873e7c0438aef5_22fa0e41322ec341b265cfd9c9a77bdd.gif" style="width: 177.00px;height: 252.38px;"/></p>',
      },
      入院记录: {
        名称: "入院记录",
        create_time: getCurrentTime("yyyy-MM-dd HH:mm"),
        id: new Date().getTime() + 2,
        file: [
          {
            name: "微信图片_20220622142610",
            type: "jpg",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/14824074228944e28ae9a5f50b8aac17_微信图片_20220622142610.jpg",
          },
          {
            name: "1628129811(1)",
            type: "jpg",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/c824a4c10a734f0184dfe45b715b9e9a_1628129811(1).jpg",
          },
          {
            name: "33333",
            type: "docx",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/e3423ccdd32543cb8a3f1c8b07f844fb_33333.docx",
          },
          {
            name: "eee",
            type: "pdf",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/667015747db443a5b90528ebe0a581d7_“心脏无忧”筛查报告.pdf",
          },
        ],
        content:
          '<p><img src="https://fqxk-test.i-tcm.cn/qhpicrootds/file/0c091f763b4741a990873e7c0438aef5_22fa0e41322ec341b265cfd9c9a77bdd.gif" alt="" data-href="https://fqxk-test.i-tcm.cn/qhpicrootds/file/0c091f763b4741a990873e7c0438aef5_22fa0e41322ec341b265cfd9c9a77bdd.gif" style="width: 177.00px;height: 252.38px;"/></p>',
      },
      首次病程录: {
        名称: "首次病程录",
        create_time: getCurrentTime("yyyy-MM-dd HH:mm"),
        id: new Date().getTime() + 3,
        file: [
          {
            name: "eee",
            type: "pdf",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/667015747db443a5b90528ebe0a581d7_“心脏无忧”筛查报告.pdf",
          },
        ],
        content:
          '<table style="width: auto;"><tbody><tr><th colSpan="1" rowSpan="1" width="auto"></th><th colSpan="1" rowSpan="1" width="auto"></th><th colSpan="1" rowSpan="1" width="auto"></th><th colSpan="1" rowSpan="1" width="auto"></th><th colSpan="1" rowSpan="1" width="auto"></th></tr><tr><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td></tr><tr><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td></tr><tr><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td></tr><tr><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td><td colSpan="1" rowSpan="1" width="auto"></td></tr></tbody></table><p><br></p>',
      },
      出院记录: {
        名称: "出院记录",
        create_time: getCurrentTime("yyyy-MM-dd HH:mm"),
        id: new Date().getTime() + 4,
        file: [
          {
            name: "3V2A3032",
            type: "jpg",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/e56c3870926b414685670cf856a97ba2_3v2a3032.jpg",
          },
          {
            name: "微信图片_20220622142607",
            type: "jpg",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/a99122dcdf954753a9a2db99aef2009b_微信图片_20220622142607.jpg",
          },
          {
            name: "微信图片_20220622142610",
            type: "jpg",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/14824074228944e28ae9a5f50b8aac17_微信图片_20220622142610.jpg",
          },
          {
            name: "1628129811(1)",
            type: "jpg",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/c824a4c10a734f0184dfe45b715b9e9a_1628129811(1).jpg",
          },
          {
            name: "33333",
            type: "docx",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/e3423ccdd32543cb8a3f1c8b07f844fb_33333.docx",
          },
          {
            name: "eee",
            type: "pdf",
            url: "https://fqxk-test.i-tcm.cn/qhpicrootds/file/667015747db443a5b90528ebe0a581d7_“心脏无忧”筛查报告.pdf",
          },
        ],
        content:
          '<p>😀</p><div data-w-e-type="todo"><input type="checkbox" disabled >是穿插 </div><p><img src="https://fqxk-test.i-tcm.cn/qhpicrootds/file/80415335549a46c5afa95e813157bffd_20230316-092326.jpg" alt="" data-href="https://fqxk-test.i-tcm.cn/qhpicrootds/file/80415335549a46c5afa95e813157bffd_20230316-092326.jpg" style="width: 333.00px;height: 208.13px;"/></p>',
      },
    };
    this.detail = this.data;
  }
  // 保存确认弹框保存
  private changeSave() {
    this.ifShowSaveConfirm = false;
    this.save().then(() => {
      this.$router.back();
    });
  }
  // 保存确认弹框不保存,切换
  private changeConfirmed() {
    this.ifShowSaveConfirm = false;
    this.$store.commit("updateIfCompose", false);
    this.$router.back();
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.ifCompose) {
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  private mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.pageType = "编辑";
    this.getDetail();
  }
}
